import React from 'react';
import { EventNameNav, EventNameNavProps } from '../components/EventNameNav';
import { WebsiteHeaderLayout_PageWidth } from '../../../../hooks/useWebsiteHeaderSettings';
import { HeaderPhoto } from '../components/HeaderPhoto/HeaderPhoto';
import PageOrScreenWidthImage from '../components/PageOrScreenWidthImage/PageOrScreenWidthImage';

interface PageWidthLayoutProps extends EventNameNavProps {
  websiteHeader: WebsiteHeaderLayout_PageWidth;
  showPlaceholder?: boolean;
}

export const PageWidthLayout = (props: PageWidthLayoutProps) => {
  const { websiteHeader, showPlaceholder = false, ...restProps } = props;

  return (
    <EventNameNav
      eventDisplayName={websiteHeader.eventDisplayName}
      {...restProps}
    >
      <HeaderPhoto
        websiteHeader={websiteHeader}
        pageSlug={restProps.pageSlug}
        pageType={restProps.page}
        showPlaceholder={showPlaceholder}
      >
        <PageOrScreenWidthImage
          variant="page"
          photoDetails={websiteHeader.headerPhoto}
          showPlaceholder={showPlaceholder}
        />
      </HeaderPhoto>
    </EventNameNav>
  );
};
